import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import Tooltip from "@components/tooltip";
import Icon from "@components/icon";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const Refresh = ({
  disabled,
  loading,
  action,
  onMouseEnter,
  onMouseLeave,
  className,
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!loading && !disabled && action) {
      action(event);
    }
  };

  return (
    <object className={cx("object-wrapper")}>
      <Tooltip
        isWithoutWrapper
        content={strings.profile_refresh}
        duration={[null, null]}
      >
        <button
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={handleClick}
          className={cx(
            "refresh",
            {
              twist: loading,
              disabled,
            },
            className
          )}
        >
          <Icon
            name="ic_refresh-out"
            size="s"
            color={
              disabled
                ? "var(--glz-color-neutral-tone-3)"
                : "var(--glz-color-neutral-tone-5)"
            }
          />
        </button>
      </Tooltip>
    </object>
  );
};

Refresh.propTypes = {
  action: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string,
};

export default observer(Refresh);
